module.exports = __webpack_public_path__ + "img/img_zhengce.03885dbd.png";